<div id="main-wrapper">

    <app-header></app-header>

    <app-sidebar></app-sidebar>

    <div class="page-wrapper">
        <div class="container-fluid">

            <!-- <app-breadcrumbs></app-breadcrumbs>-->

        </div>
        <div class="col-12">
            <div class="card">
                <div style="text-align: right;">

                </div>
                <div class="card-body">
                    <app-breadcrumbs></app-breadcrumbs>
                    <router-outlet></router-outlet>

                </div>
            </div>
        </div>
        <!--  <router-outlet></router-outlet> -->

    </div>
    <br>
    <footer class="footer">
        <p style="text-align: center; color: #8f124d;"><b>Colegio de Estudios Científicos y Tecnológicos del Estado de Veracruz • Derechos reservados • ©️ {{anio}} -</b><a style="color: #8f124d" href="http://cecytev.edu.mx/transparencia/avisosdeprivacidad/" target="_blank"><b>Avisos de Privacidad - Versión 1.0</b> </a>

        </p>

    </footer>

</div>